import { render, staticRenderFns } from "./list-design.vue?vue&type=template&id=0c0612d5&"
import script from "./list-design.vue?vue&type=script&lang=js&"
export * from "./list-design.vue?vue&type=script&lang=js&"
import style0 from "./list-design.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports